export default {
  data() {
    return {
      countries: [],
      countriesSelect: [],
      notificationTypes: [],
      notificationTypesSelect: []
    }
  },
  methods: {
    async fetchCountries() {
      let params = {
        sort: [
          {
            key: 'name',
            direction: 'asc'
          }
        ]
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'countries', { params: params })
        .then(response => {
          this.countries = response.body.data
          this.countriesSelect = this.countries.map((item) => {
            return {
              value: item.iso_code,
              text: item.name
            }
          })
        })
    },
    async fetchShippingTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-types', params)
        .then(response => {
          this.shippingTypes = response.body.data
          this.shippingTypesSelect = this.shippingTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Shipping Types Fetched OK!')
        })
    },
    async fetchShippingSizes() {
      let params = {
        params: {
          sort: [{
            key: 'max_weight',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'sizes', params)
        .then(response => {
          this.shippingSizes = response.body.data.map(x => {
            x.raw = x.max_width * x.max_height * x.max_length // parseInt([x.max_width, x.max_height, x.max_length].sort((a, b) => b - a).join(''))
            x.volumetricWeight = x.raw / 5000
            return x
          })
          this.shippingSizesSelect = this.shippingSizes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Shipping Sizes Fetched OK!')
        })
    },
    async fetchNotificationTypes() {
      let params = {
        params: {
          sort: [{
            key: 'name',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'notification-types', params)
        .then(response => {
          this.notificationTypes = response.body.data

          // Filter out country excluded notifications
          console.log(window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code))
          const countryExcludedNotifications = window.countries.find(x => x.iso_code === this.$store.getters.profile.company.country_iso_code).notification_configs.map(x => {
            return x.notification_type_id
          })
          this.notificationTypes = this.notificationTypes.filter(x => countryExcludedNotifications.indexOf(x.id) === -1)

          this.notificationTypesSelect = this.notificationTypes.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Notification Types Fetched OK!')
        })
    },
    async fetchShippingSettings() {
      let params = {
        params: {
          sort: [{
            key: 'id',
            direction: 'asc'
          }]
        }
      }
      return this.$http.get(this.$appConfig.api.baseUrl + 'shipping-setting-options', params)
        .then(response => {
          this.shippingSettings = response.body.data

          this.shippingSettingsSelect = this.shippingSettings.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })

          console.log('Shipping Settings Fetched OK!')
        })
    },
    async fetchCompaniesSegments() {
      let params = {
        params: {
          sort: [{
            key: 'id',
            direction: 'asc'
          }]
        }
      }
      return await this.$http.get(this.$appConfig.api.baseUrl + 'companies-segments', params)
        .then(response => {
          this.companiesSegments = response.body.data
          this.companiesSegmentsSelect = this.companiesSegments.map((item) => {
            return {
              value: item.id,
              text: item.name
            }
          })
          console.log('Companies Segments Fetched OK!')
        })
    }
  }
}
